import React from 'react'

interface State {
    tableScrollHeight: number | 'auto'
}

const NAV_HEIGHT = 55 // px

export default class Scrollable extends React.Component<Object, State> {

    public state: State = {
        tableScrollHeight: 'auto'
    }

    public setOverflowTable = () => {
        const $overflowTable: HTMLElement | null = document.getElementById('table-overflow--y')
        const offsetTop = $overflowTable ? $overflowTable.getBoundingClientRect().top : 0
        this.setState({
            tableScrollHeight: (window.innerHeight - offsetTop) - NAV_HEIGHT
        })
    }

    public componentWillUnmount() {
        document.getElementsByTagName('html')[0].classList.remove('no--scroll')
        window.removeEventListener('resize', this.setOverflowTable)
    }

    public componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('no--scroll')
        window.addEventListener('resize', this.setOverflowTable)
        this.setOverflowTable()
    }

    public handleResize = () => {
        this.setOverflowTable()
    }

    render() {
        return (
            <div id="table-overflow--y" style={{ height: this.state.tableScrollHeight }}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Scrollable/index.tsx